import React from 'react';

interface ButtonColor {
  normal?: string;
  disabled?: string;
}

interface SubmitButtonProps {
  className?: string;
  color?: ButtonColor;
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}


const defaultClassName =
  'w-4/5 py-3 rounded-lg text-white font-medium transition-colors duration-150';

const defaultNormalColor = 'bg-primary hover:bg-accent';
const defaultDisabledColor = 'bg-gray-300 cursor-not-allowed';

const SubmitButton: React.FC<SubmitButtonProps> = ({
  className,
  color,
  onClick,
  disabled,
  children
}) => {
  const normalColor = color?.normal || defaultNormalColor;
  const disabledColor = color?.disabled || defaultDisabledColor;
  const currentColor = disabled ? disabledColor : normalColor;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={
        className
          ? `${className} ${currentColor}`
          : `${defaultClassName} ${currentColor}`
      }
    >
      {children}
    </button>
  );
};

export default SubmitButton;